export default {
  NO_ORDERS: 'Nenhum pedido no momento :(',
  NO_ORDERS_OPENED: 'Você não possui pedidos abertos.',
  NO_ORDERS_CLOSED: null,
  ERROR_AWAIT: 'Algo aconteceu, por favor aguarde que logo vamos exibir os seus pedidos :)'
}
